import React from 'react';

/**
 * Component to show a validation error for a form input component.
 *
 * @param error the error message
 * @return the created {@link React.JSX.Element}.
 * @constructor
 */
export function ValidationErrorMessage({
  id,
  error
}: Readonly<{
  id: string;
  error: string;
}>): React.JSX.Element {
  return (
    <div className="error-message" id={id}>
      {error}
    </div>
  );
}
